<template>
  <div class="checkbox">
    <label class="item-name"><i class="required" v-show="component.properties.required">*</i>{{initComponent.name}}</label>
    <div class="component-content">
      <el-checkbox-group v-model="value" class="checkbox-group" :style="{'height':height}">
        <el-checkbox v-for="(option, index) in options"
                     :key="index"
                     :label="option.value"
                     disabled></el-checkbox>
      </el-checkbox-group>
    </div>
  </div>
</template>

<script>
import { componentMixin, dataSourceMixin } from '../mixins'
import { heightMixin } from '@/components/shared/designAndRuntimeMixins/mixins.js'
export default {
  name: 'rc-checkbox',
  props: ['initComponent'],
  mixins: [ componentMixin, heightMixin, dataSourceMixin ],
  data () {
    return {
      value: [],
      options: [],
      component: this.initComponent
    }
  },
  mounted () {
    if (this.initComponent.properties.template && this.initComponent.properties.template.enable) {
      this.loadTemplateOptions()
    } else if (this.initComponent.properties.dataSource && this.initComponent.properties.dataSource.enable) {
      this.loadDataSourceOptions()
    }
  },
  watch: {
    'initComponent.properties.template.stringOptions' () {
      this.loadTemplateOptions()
    },
    'initComponent.properties.dataSource': {
      handler (value) {
        value.reportId && this.loadDataSourceOptions()
      },
      deep: true

    }
  }
}
</script>

<style lang="scss">
.checkbox {
  height: calc(100% - 46px);
  .checkbox-group {
    overflow-y: hidden;
    width: 100%;
    height: 100%;
    label.el-checkbox{
        display: block;
        margin-left: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        height: 28px;
        line-height: 28px;
     }
  }
  .el-checkbox__inner {
    border-radius: 2px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/form/components/checkbox/rc-checkbox.vue